import { render, staticRenderFns } from "./tipo-formulacao.vue?vue&type=template&id=027c85ea&"
import script from "./tipo-formulacao.vue?vue&type=script&lang=js&"
export * from "./tipo-formulacao.vue?vue&type=script&lang=js&"
import style0 from "./tipo-formulacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports